import Container from "react-bootstrap/Container";
import { Row, Col, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import "../styles/dualEducation.css";
import ResultsSection from "../components/ResultSection";

export default function Rolunk() {
  return (
    <>
      <Container className="hero mx-1 px-1 mx-md-auto">
        <span className="badge">FÜGGETLEN • SIKERDÍJAS • SZAKÉRTŐ</span>

        <h1 className="title">A Financials.hu-ról</h1>

        <p className="subtitle">
          Intézd vállalkozásod pénzügyeit egy független szakértővel – a
          kalkulációtól a szerződéskötésig! Segítünk megtalálni a legkedvezőbb
          megoldásokat, tiszta sikerdíjas alapon.
        </p>

        <div className="lead opacity-75 mt-4" style={{ maxWidth: "820px" }}>
          Több éves banki, pályázatkezelési és pályázatírói tapasztalattal
          rendelkező cégünk az aktuális pályázati lehetőségek ismeretében nyújt
          segítséget. Legyen szó a munkavállalók képzési támogatásáról,
          pályázatról, vagy a banki költségek csökkentéséről.
        </div>
      </Container>

      <Container>
        <section className="section">
          <h2 className="h2 text-center mb-5">Miben segítünk?</h2>
          <Row className="g-4">
            <Col md={4}>
              <Card className="card h-100">
                <div className="kpi">Bankolás</div>
                <div className="muted mt-2">
                  Bankszámlák kiválasztása és költségeinek optimalizálása.
                </div>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="card h-100">
                <div className="kpi">Pályázatok</div>
                <div className="muted mt-2">
                  Támogatási lehetőségek feltérképezése és teljes körű
                  ügyintézése.
                </div>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="card h-100">
                <div className="kpi">Hitelek</div>
                <div className="muted mt-2">
                  Egyedi hitel- és finanszírozási megoldások kidolgozása.
                </div>
              </Card>
            </Col>
          </Row>
        </section>

        <section className="section" id="miert-mi">
          <h2 className="h2">Miért válaszd a Financials.hu-t?</h2>
          <p className="lead">
            Szolgáltatásaink kizárólag sikerdíjas alapon működnek, így csak
            akkor kell fizetned, ha valódi eredményt érünk el.
          </p>

          <Row className="g-4 mt-2">
            <Col md={6}>
              <ul className="list check-list">
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Független szakértők:</strong> Több céggel működünk
                    együtt azért, hogy a legjobb megoldást találjuk.
                  </div>
                </li>
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Sikerdíjas modell:</strong> Csak az eredményért
                    fizetsz, nincs rejtett költség vagy előre fizetendő díj.
                  </div>
                </li>
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Szakértői tanácsadás:</strong> Minden kérdésedre
                    részletes, személyre szabott választ kapsz, a jogi és
                    pénzügyi részleteket is beleértve.
                  </div>
                </li>
              </ul>
            </Col>
            <Col md={6}>
              <ul className="list check-list">
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Időmegtakarítás:</strong> Az adminisztrációt,
                    pályázati folyamatokat és pénzügyi dokumentációt mi intézzük
                    helyetted.
                  </div>
                </li>
                <li className="mb-4">
                  <FontAwesomeIcon icon={faCheck} className="me-3" />
                  <div>
                    <strong>Teljes körű megoldások:</strong> Egy kézben
                    tarthatod a céges hiteleket, támogatásokat és a bankszámla
                    optimalizálást.
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
        </section>

        <Container>
          <h2 className="h2 text-center">Eredményeink</h2>
          <ResultsSection />
        </Container>
      </Container>
    </>
  );
}
